import React from "react";

import { faUser } from "@fortawesome/pro-solid-svg-icons/faUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import { Person } from "@mapmycustomers/shared/types/entity";

import styles from "./PersonName.module.scss";

interface Props {
  person: Person;
}

const PersonNameWithAddress: React.FC<Props> = ({ person }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={faUser} />
      </div>
      <div className={styles.details}>
        <div className={styles.name}>{person.name}</div>
        <div className={styles.address}>
          {person.address ??
            intl.formatMessage({
              id: "person.label.noAddress",
              defaultMessage: "No address",
              description: "No address label",
            })}
        </div>
      </div>
    </div>
  );
};

export default PersonNameWithAddress;
